function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 18.7497,
  r: 10.4167,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9999 0C14.6611 0 6.25 8.34748 6.25 18.6079C6.25 24.3472 9.22743 31.3133 15.0999 39.3128C19.3973 45.1671 23.6321 49.3423 23.8103 49.5173C24.1378 49.8388 24.5688 50 25.0002 50C25.4191 50 25.8383 49.8479 26.1633 49.5427C26.3419 49.375 30.5873 45.3688 34.8929 39.5954C40.7701 31.7144 43.75 24.6533 43.75 18.6079C43.7498 8.34748 35.3385 0 24.9999 0ZM24.9999 26.6413C19.9454 26.6413 15.8333 22.6323 15.8333 17.7046C15.8333 12.777 19.9455 8.76799 24.9999 8.76799C30.0543 8.76799 34.1665 12.777 34.1665 17.7046C34.1665 22.6323 30.0542 26.6413 24.9999 26.6413Z",
  fill: "#B01BAE"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 18,
  r: 12,
  fill: "white"
});

function SvgMarkerActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerActive);
export default __webpack_public_path__ + "static/media/marker-active.e3ee2a71.svg";
export { ForwardRef as ReactComponent };